// Indian States with Hindi names
export const INDIAN_STATES = [
  { code: 'AP', name: 'Andhra Pradesh', nameHindi: 'आंध्र प्रदेश' },
  { code: 'AR', name: 'Arunachal Pradesh', nameHindi: 'अरुणाचल प्रदेश' },
  { code: 'AS', name: 'Assam', nameHindi: 'असम' },
  { code: 'BR', name: 'Bihar', nameHindi: 'बिहार' },
  { code: 'CG', name: 'Chhattisgarh', nameHindi: 'छत्तीसगढ़' },
  { code: 'GA', name: 'Goa', nameHindi: 'गोवा' },
  { code: 'GJ', name: 'Gujarat', nameHindi: 'गुजरात' },
  { code: 'HR', name: 'Haryana', nameHindi: 'हरियाणा' },
  { code: 'HP', name: 'Himachal Pradesh', nameHindi: 'हिमाचल प्रदेश' },
  { code: 'JH', name: 'Jharkhand', nameHindi: 'झारखंड' },
  { code: 'KA', name: 'Karnataka', nameHindi: 'कर्नाटक' },
  { code: 'KL', name: 'Kerala', nameHindi: 'केरल' },
  { code: 'MP', name: 'Madhya Pradesh', nameHindi: 'मध्य प्रदेश' },
  { code: 'MH', name: 'Maharashtra', nameHindi: 'महाराष्ट्र' },
  { code: 'MN', name: 'Manipur', nameHindi: 'मणिपुर' },
  { code: 'ML', name: 'Meghalaya', nameHindi: 'मेघालय' },
  { code: 'MZ', name: 'Mizoram', nameHindi: 'मिजोरम' },
  { code: 'NL', name: 'Nagaland', nameHindi: 'नागालैंड' },
  { code: 'OD', name: 'Odisha', nameHindi: 'ओडिशा' },
  { code: 'PB', name: 'Punjab', nameHindi: 'पंजाब' },
  { code: 'RJ', name: 'Rajasthan', nameHindi: 'राजस्थान' },
  { code: 'SK', name: 'Sikkim', nameHindi: 'सिक्किम' },
  { code: 'TN', name: 'Tamil Nadu', nameHindi: 'तमिल नाडु' },
  { code: 'TG', name: 'Telangana', nameHindi: 'तेलंगाना' },
  { code: 'TR', name: 'Tripura', nameHindi: 'त्रिपुरा' },
  { code: 'UP', name: 'Uttar Pradesh', nameHindi: 'उत्तर प्रदेश' },
  { code: 'UK', name: 'Uttarakhand', nameHindi: 'उत्तराखंड' },
  { code: 'WB', name: 'West Bengal', nameHindi: 'पश्चिम बंगाल' },
  // Union Territories
  { code: 'AN', name: 'Andaman & Nicobar', nameHindi: 'अंडमान और निकोबार' },
  { code: 'CH', name: 'Chandigarh', nameHindi: 'चंडीगढ़' },
  { code: 'DN', name: 'Dadra & Nagar Haveli and Daman & Diu', nameHindi: 'दादरा और नगर हवेली' },
  { code: 'DL', name: 'Delhi', nameHindi: 'दिल्ली' },
  { code: 'JK', name: 'Jammu & Kashmir', nameHindi: 'जम्मू और कश्मीर' },
  { code: 'LA', name: 'Ladakh', nameHindi: 'लद्दाख' },
  { code: 'LD', name: 'Lakshadweep', nameHindi: 'लक्षद्वीप' },
  { code: 'PY', name: 'Puducherry', nameHindi: 'पुडुचेरी' },
];

// Major districts for key agricultural states
export const DISTRICTS_BY_STATE = {
  UP: ['Agra', 'Aligarh', 'Allahabad', 'Ambedkar Nagar', 'Amethi', 'Amroha', 'Auraiya', 'Azamgarh', 'Baghpat', 'Bahraich', 'Ballia', 'Balrampur', 'Banda', 'Barabanki', 'Bareilly', 'Basti', 'Bhadohi', 'Bijnor', 'Budaun', 'Bulandshahr', 'Chandauli', 'Chitrakoot', 'Deoria', 'Etah', 'Etawah', 'Faizabad', 'Farrukhabad', 'Fatehpur', 'Firozabad', 'Gautam Buddha Nagar', 'Ghaziabad', 'Ghazipur', 'Gonda', 'Gorakhpur', 'Hamirpur', 'Hapur', 'Hardoi', 'Hathras', 'Jalaun', 'Jaunpur', 'Jhansi', 'Kannauj', 'Kanpur Dehat', 'Kanpur Nagar', 'Kasganj', 'Kaushambi', 'Kushinagar', 'Lakhimpur Kheri', 'Lalitpur', 'Lucknow', 'Maharajganj', 'Mahoba', 'Mainpuri', 'Mathura', 'Mau', 'Meerut', 'Mirzapur', 'Moradabad', 'Muzaffarnagar', 'Pilibhit', 'Pratapgarh', 'Raebareli', 'Rampur', 'Saharanpur', 'Sambhal', 'Sant Kabir Nagar', 'Shahjahanpur', 'Shamli', 'Shravasti', 'Siddharthnagar', 'Sitapur', 'Sonbhadra', 'Sultanpur', 'Unnao', 'Varanasi'],
  PB: ['Amritsar', 'Barnala', 'Bathinda', 'Faridkot', 'Fatehgarh Sahib', 'Fazilka', 'Ferozepur', 'Gurdaspur', 'Hoshiarpur', 'Jalandhar', 'Kapurthala', 'Ludhiana', 'Mansa', 'Moga', 'Mohali', 'Muktsar', 'Nawanshahr', 'Pathankot', 'Patiala', 'Ropar', 'Sangrur', 'Shahid Bhagat Singh Nagar', 'Tarn Taran'],
  HR: ['Ambala', 'Bhiwani', 'Charkhi Dadri', 'Faridabad', 'Fatehabad', 'Gurugram', 'Hisar', 'Jhajjar', 'Jind', 'Kaithal', 'Karnal', 'Kurukshetra', 'Mahendragarh', 'Nuh', 'Palwal', 'Panchkula', 'Panipat', 'Rewari', 'Rohtak', 'Sirsa', 'Sonipat', 'Yamunanagar'],
  MH: ['Ahmednagar', 'Akola', 'Amravati', 'Aurangabad', 'Beed', 'Bhandara', 'Buldhana', 'Chandrapur', 'Dhule', 'Gadchiroli', 'Gondia', 'Hingoli', 'Jalgaon', 'Jalna', 'Kolhapur', 'Latur', 'Mumbai City', 'Mumbai Suburban', 'Nagpur', 'Nanded', 'Nandurbar', 'Nashik', 'Osmanabad', 'Palghar', 'Parbhani', 'Pune', 'Raigad', 'Ratnagiri', 'Sangli', 'Satara', 'Sindhudurg', 'Solapur', 'Thane', 'Wardha', 'Washim', 'Yavatmal'],
  MP: ['Agar Malwa', 'Alirajpur', 'Anuppur', 'Ashoknagar', 'Balaghat', 'Barwani', 'Betul', 'Bhind', 'Bhopal', 'Burhanpur', 'Chhatarpur', 'Chhindwara', 'Damoh', 'Datia', 'Dewas', 'Dhar', 'Dindori', 'Guna', 'Gwalior', 'Harda', 'Hoshangabad', 'Indore', 'Jabalpur', 'Jhabua', 'Katni', 'Khandwa', 'Khargone', 'Mandla', 'Mandsaur', 'Morena', 'Narsinghpur', 'Neemuch', 'Panna', 'Raisen', 'Rajgarh', 'Ratlam', 'Rewa', 'Sagar', 'Satna', 'Sehore', 'Seoni', 'Shahdol', 'Shajapur', 'Sheopur', 'Shivpuri', 'Sidhi', 'Singrauli', 'Tikamgarh', 'Ujjain', 'Umaria', 'Vidisha'],
  GJ: ['Ahmedabad', 'Amreli', 'Anand', 'Aravalli', 'Banaskantha', 'Bharuch', 'Bhavnagar', 'Botad', 'Chhota Udaipur', 'Dahod', 'Dang', 'Devbhoomi Dwarka', 'Gandhinagar', 'Gir Somnath', 'Jamnagar', 'Junagadh', 'Kheda', 'Kutch', 'Mahisagar', 'Mehsana', 'Morbi', 'Narmada', 'Navsari', 'Panchmahal', 'Patan', 'Porbandar', 'Rajkot', 'Sabarkantha', 'Surat', 'Surendranagar', 'Tapi', 'Vadodara', 'Valsad'],
  RJ: ['Ajmer', 'Alwar', 'Banswara', 'Baran', 'Barmer', 'Bharatpur', 'Bhilwara', 'Bikaner', 'Bundi', 'Chittorgarh', 'Churu', 'Dausa', 'Dholpur', 'Dungarpur', 'Hanumangarh', 'Jaipur', 'Jaisalmer', 'Jalore', 'Jhalawar', 'Jhunjhunu', 'Jodhpur', 'Karauli', 'Kota', 'Nagaur', 'Pali', 'Pratapgarh', 'Rajsamand', 'Sawai Madhopur', 'Sikar', 'Sirohi', 'Sri Ganganagar', 'Tonk', 'Udaipur'],
  KA: ['Bagalkot', 'Ballari', 'Belagavi', 'Bengaluru Rural', 'Bengaluru Urban', 'Bidar', 'Chamarajanagar', 'Chikkaballapur', 'Chikkamagaluru', 'Chitradurga', 'Dakshina Kannada', 'Davanagere', 'Dharwad', 'Gadag', 'Hassan', 'Haveri', 'Kalaburagi', 'Kodagu', 'Kolar', 'Koppal', 'Mandya', 'Mysuru', 'Raichur', 'Ramanagara', 'Shivamogga', 'Tumkur', 'Udupi', 'Uttara Kannada', 'Vijayapura', 'Yadgir'],
  AP: ['Anantapur', 'Chittoor', 'East Godavari', 'Guntur', 'Krishna', 'Kurnool', 'Nellore', 'Prakasam', 'Srikakulam', 'Visakhapatnam', 'Vizianagaram', 'West Godavari', 'YSR Kadapa'],
  TG: ['Adilabad', 'Bhadradri Kothagudem', 'Hyderabad', 'Jagtial', 'Jangaon', 'Jayashankar Bhupalpally', 'Jogulamba Gadwal', 'Kamareddy', 'Karimnagar', 'Khammam', 'Kumuram Bheem', 'Mahabubabad', 'Mahabubnagar', 'Mancherial', 'Medak', 'Medchal', 'Nagarkurnool', 'Nalgonda', 'Nirmal', 'Nizamabad', 'Peddapalli', 'Rajanna Sircilla', 'Ranga Reddy', 'Sangareddy', 'Siddipet', 'Suryapet', 'Vikarabad', 'Wanaparthy', 'Warangal Rural', 'Warangal Urban', 'Yadadri Bhuvanagiri'],
  BR: ['Araria', 'Arwal', 'Aurangabad', 'Banka', 'Begusarai', 'Bhagalpur', 'Bhojpur', 'Buxar', 'Darbhanga', 'East Champaran', 'Gaya', 'Gopalganj', 'Jamui', 'Jehanabad', 'Kaimur', 'Katihar', 'Khagaria', 'Kishanganj', 'Lakhisarai', 'Madhepura', 'Madhubani', 'Munger', 'Muzaffarpur', 'Nalanda', 'Nawada', 'Patna', 'Purnia', 'Rohtas', 'Saharsa', 'Samastipur', 'Saran', 'Sheikhpura', 'Sheohar', 'Sitamarhi', 'Siwan', 'Supaul', 'Vaishali', 'West Champaran'],
  WB: ['Alipurduar', 'Bankura', 'Birbhum', 'Cooch Behar', 'Dakshin Dinajpur', 'Darjeeling', 'Hooghly', 'Howrah', 'Jalpaiguri', 'Jhargram', 'Kalimpong', 'Kolkata', 'Malda', 'Murshidabad', 'Nadia', 'North 24 Parganas', 'Paschim Bardhaman', 'Paschim Medinipur', 'Purba Bardhaman', 'Purba Medinipur', 'Purulia', 'South 24 Parganas', 'Uttar Dinajpur'],
  TN: ['Ariyalur', 'Chengalpattu', 'Chennai', 'Coimbatore', 'Cuddalore', 'Dharmapuri', 'Dindigul', 'Erode', 'Kallakurichi', 'Kancheepuram', 'Kanyakumari', 'Karur', 'Krishnagiri', 'Madurai', 'Mayiladuthurai', 'Nagapattinam', 'Namakkal', 'Nilgiris', 'Perambalur', 'Pudukkottai', 'Ramanathapuram', 'Ranipet', 'Salem', 'Sivaganga', 'Tenkasi', 'Thanjavur', 'Theni', 'Thoothukudi', 'Tiruchirappalli', 'Tirunelveli', 'Tirupathur', 'Tiruppur', 'Tiruvallur', 'Tiruvannamalai', 'Tiruvarur', 'Vellore', 'Villupuram', 'Virudhunagar'],
  KL: ['Alappuzha', 'Ernakulam', 'Idukki', 'Kannur', 'Kasaragod', 'Kollam', 'Kottayam', 'Kozhikode', 'Malappuram', 'Palakkad', 'Pathanamthitta', 'Thiruvananthapuram', 'Thrissur', 'Wayanad'],
  AS: ['Baksa', 'Barpeta', 'Biswanath', 'Bongaigaon', 'Cachar', 'Charaideo', 'Chirang', 'Darrang', 'Dhemaji', 'Dhubri', 'Dibrugarh', 'Dima Hasao', 'Goalpara', 'Golaghat', 'Hailakandi', 'Hojai', 'Jorhat', 'Kamrup', 'Kamrup Metropolitan', 'Karbi Anglong', 'Karimganj', 'Kokrajhar', 'Lakhimpur', 'Majuli', 'Morigaon', 'Nagaon', 'Nalbari', 'Sivasagar', 'Sonitpur', 'South Salmara-Mankachar', 'Tinsukia', 'Udalguri', 'West Karbi Anglong'],
  OD: ['Angul', 'Balangir', 'Balasore', 'Bargarh', 'Bhadrak', 'Boudh', 'Cuttack', 'Deogarh', 'Dhenkanal', 'Gajapati', 'Ganjam', 'Jagatsinghpur', 'Jajpur', 'Jharsuguda', 'Kalahandi', 'Kandhamal', 'Kendrapara', 'Kendujhar', 'Khordha', 'Koraput', 'Malkangiri', 'Mayurbhanj', 'Nabarangpur', 'Nayagarh', 'Nuapada', 'Puri', 'Rayagada', 'Sambalpur', 'Subarnapur', 'Sundargarh'],
  CG: ['Balod', 'Baloda Bazar', 'Balrampur', 'Bastar', 'Bemetara', 'Bijapur', 'Bilaspur', 'Dantewada', 'Dhamtari', 'Durg', 'Gariyaband', 'Gaurela-Pendra-Marwahi', 'Janjgir-Champa', 'Jashpur', 'Kabirdham', 'Kanker', 'Kondagaon', 'Korba', 'Koriya', 'Mahasamund', 'Mungeli', 'Narayanpur', 'Raigarh', 'Raipur', 'Rajnandgaon', 'Sukma', 'Surajpur', 'Surguja'],
  JH: ['Bokaro', 'Chatra', 'Deoghar', 'Dhanbad', 'Dumka', 'East Singhbhum', 'Garhwa', 'Giridih', 'Godda', 'Gumla', 'Hazaribagh', 'Jamtara', 'Khunti', 'Koderma', 'Latehar', 'Lohardaga', 'Pakur', 'Palamu', 'Ramgarh', 'Ranchi', 'Sahebganj', 'Seraikela Kharsawan', 'Simdega', 'West Singhbhum'],
  HP: ['Bilaspur', 'Chamba', 'Hamirpur', 'Kangra', 'Kinnaur', 'Kullu', 'Lahaul Spiti', 'Mandi', 'Shimla', 'Sirmaur', 'Solan', 'Una'],
  UK: ['Almora', 'Bageshwar', 'Chamoli', 'Champawat', 'Dehradun', 'Haridwar', 'Nainital', 'Pauri Garhwal', 'Pithoragarh', 'Rudraprayag', 'Tehri Garhwal', 'Udham Singh Nagar', 'Uttarkashi'],
};

export const CROPS_LIST = {
  vegetables: [
    { name: 'Tomato', nameHindi: 'टमाटर', emoji: '🍅', season: ['kharif', 'rabi', 'zaid'] },
    { name: 'Potato', nameHindi: 'आलू', emoji: '🥔', season: ['rabi'] },
    { name: 'Onion', nameHindi: 'प्याज', emoji: '🧅', season: ['rabi', 'kharif'] },
    { name: 'Cauliflower', nameHindi: 'फूलगोभी', emoji: '🥦', season: ['rabi'] },
    { name: 'Cabbage', nameHindi: 'पत्तागोभी', emoji: '🥬', season: ['rabi'] },
    { name: 'Brinjal', nameHindi: 'बैंगन', emoji: '🍆', season: ['kharif', 'rabi'] },
    { name: 'Okra', nameHindi: 'भिंडी', emoji: '🌿', season: ['kharif', 'zaid'] },
    { name: 'Spinach', nameHindi: 'पालक', emoji: '🥬', season: ['rabi'] },
    { name: 'Carrot', nameHindi: 'गाजर', emoji: '🥕', season: ['rabi'] },
    { name: 'Radish', nameHindi: 'मूली', emoji: '🌱', season: ['rabi'] },
    { name: 'Peas', nameHindi: 'मटर', emoji: '🫛', season: ['rabi'] },
    { name: 'Bitter Gourd', nameHindi: 'करेला', emoji: '🫑', season: ['kharif', 'zaid'] },
    { name: 'Bottle Gourd', nameHindi: 'लौकी', emoji: '🎃', season: ['kharif', 'zaid'] },
    { name: 'Ridge Gourd', nameHindi: 'तोरई', emoji: '🥒', season: ['kharif'] },
    { name: 'Pumpkin', nameHindi: 'कद्दू', emoji: '🎃', season: ['kharif'] },
    { name: 'Garlic', nameHindi: 'लहसुन', emoji: '🧄', season: ['rabi'] },
    { name: 'Ginger', nameHindi: 'अदरक', emoji: '🫚', season: ['kharif'] },
  ],
  cereals: [
    { name: 'Wheat', nameHindi: 'गेहूं', emoji: '🌾', season: ['rabi'] },
    { name: 'Rice', nameHindi: 'धान', emoji: '🍚', season: ['kharif'] },
    { name: 'Maize', nameHindi: 'मक्का', emoji: '🌽', season: ['kharif', 'zaid'] },
    { name: 'Barley', nameHindi: 'जौ', emoji: '🌾', season: ['rabi'] },
    { name: 'Jowar', nameHindi: 'ज्वार', emoji: '🌾', season: ['kharif', 'rabi'] },
    { name: 'Bajra', nameHindi: 'बाजरा', emoji: '🌾', season: ['kharif'] },
    { name: 'Ragi', nameHindi: 'रागी', emoji: '🌾', season: ['kharif'] },
  ],
  pulses: [
    { name: 'Chana', nameHindi: 'चना', emoji: '🫘', season: ['rabi'] },
    { name: 'Arhar', nameHindi: 'अरहर', emoji: '🫘', season: ['kharif'] },
    { name: 'Moong', nameHindi: 'मूंग', emoji: '🫘', season: ['kharif', 'zaid'] },
    { name: 'Urad', nameHindi: 'उड़द', emoji: '🫘', season: ['kharif'] },
    { name: 'Masoor', nameHindi: 'मसूर', emoji: '🫘', season: ['rabi'] },
    { name: 'Rajma', nameHindi: 'राजमा', emoji: '🫘', season: ['rabi'] },
    { name: 'Soybean', nameHindi: 'सोयाबीन', emoji: '🫘', season: ['kharif'] },
    { name: 'Moth Bean', nameHindi: 'मोठ', emoji: '🫘', season: ['kharif'] },
  ],
  cashCrops: [
    { name: 'Sugarcane', nameHindi: 'गन्ना', emoji: '🎋', season: ['kharif'] },
    { name: 'Cotton', nameHindi: 'कपास', emoji: '☁️', season: ['kharif'] },
    { name: 'Jute', nameHindi: 'जूट', emoji: '🌿', season: ['kharif'] },
    { name: 'Tobacco', nameHindi: 'तंबाकू', emoji: '🌿', season: ['rabi'] },
  ],
  fruits: [
    { name: 'Mango', nameHindi: 'आम', emoji: '🥭', season: ['zaid'] },
    { name: 'Banana', nameHindi: 'केला', emoji: '🍌', season: ['kharif', 'rabi', 'zaid'] },
    { name: 'Papaya', nameHindi: 'पपीता', emoji: '🍑', season: ['kharif'] },
    { name: 'Guava', nameHindi: 'अमरूद', emoji: '🍈', season: ['rabi'] },
    { name: 'Pomegranate', nameHindi: 'अनार', emoji: '❤️', season: ['rabi'] },
    { name: 'Grapes', nameHindi: 'अंगूर', emoji: '🍇', season: ['rabi'] },
    { name: 'Apple', nameHindi: 'सेब', emoji: '🍎', season: ['rabi'] },
    { name: 'Orange', nameHindi: 'संतरा', emoji: '🍊', season: ['rabi'] },
    { name: 'Watermelon', nameHindi: 'तरबूज', emoji: '🍉', season: ['zaid'] },
  ],
  spices: [
    { name: 'Turmeric', nameHindi: 'हल्दी', emoji: '🟡', season: ['kharif'] },
    { name: 'Chilli', nameHindi: 'मिर्च', emoji: '🌶️', season: ['kharif', 'rabi'] },
    { name: 'Coriander', nameHindi: 'धनिया', emoji: '🌿', season: ['rabi'] },
    { name: 'Cumin', nameHindi: 'जीरा', emoji: '🌿', season: ['rabi'] },
    { name: 'Fenugreek', nameHindi: 'मेथी', emoji: '🌿', season: ['rabi'] },
  ],
  oilseeds: [
    { name: 'Groundnut', nameHindi: 'मूंगफली', emoji: '🥜', season: ['kharif'] },
    { name: 'Mustard', nameHindi: 'सरसों', emoji: '🌼', season: ['rabi'] },
    { name: 'Sunflower', nameHindi: 'सूरजमुखी', emoji: '🌻', season: ['rabi', 'zaid'] },
    { name: 'Sesame', nameHindi: 'तिल', emoji: '⚪', season: ['kharif'] },
    { name: 'Linseed', nameHindi: 'अलसी', emoji: '🌿', season: ['rabi'] },
    { name: 'Castor', nameHindi: 'अरंडी', emoji: '🌿', season: ['kharif'] },
  ],
};

export const LANGUAGES = [
  { code: 'hi', name: 'हिंदी', english: 'Hindi', script: 'Devanagari', rtl: false },
  { code: 'en', name: 'English', english: 'English', script: 'Latin', rtl: false },
  { code: 'pa', name: 'ਪੰਜਾਬੀ', english: 'Punjabi', script: 'Gurmukhi', rtl: false },
  { code: 'mr', name: 'मराठी', english: 'Marathi', script: 'Devanagari', rtl: false },
  { code: 'te', name: 'తెలుగు', english: 'Telugu', script: 'Telugu', rtl: false },
  { code: 'ta', name: 'தமிழ்', english: 'Tamil', script: 'Tamil', rtl: false },
  { code: 'kn', name: 'ಕನ್ನಡ', english: 'Kannada', script: 'Kannada', rtl: false },
  { code: 'gu', name: 'ગુજરાતી', english: 'Gujarati', script: 'Gujarati', rtl: false },
  { code: 'bn', name: 'বাংলা', english: 'Bengali', script: 'Bengali', rtl: false },
  { code: 'ml', name: 'മലയാളം', english: 'Malayalam', script: 'Malayalam', rtl: false },
  { code: 'od', name: 'ଓଡ଼ିଆ', english: 'Odia', script: 'Odia', rtl: false },
  { code: 'as', name: 'অসমীয়া', english: 'Assamese', script: 'Bengali', rtl: false },
  { code: 'ur', name: 'اردو', english: 'Urdu', script: 'Nastaliq', rtl: true },
];

export const CROP_SEASONS = {
  kharif: {
    name: 'Kharif',
    nameHindi: 'खरीफ',
    months: [6, 7, 8, 9, 10],
    months_names: ['June', 'July', 'Aug', 'Sep', 'Oct'],
    description: 'Sown at the beginning of monsoon, harvested in autumn',
    crops: ['Rice', 'Maize', 'Cotton', 'Sugarcane', 'Groundnut', 'Soybean', 'Bajra', 'Jowar'],
  },
  rabi: {
    name: 'Rabi',
    nameHindi: 'रबी',
    months: [11, 12, 1, 2, 3, 4],
    months_names: ['Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr'],
    description: 'Sown in winter, harvested in spring',
    crops: ['Wheat', 'Barley', 'Mustard', 'Potato', 'Peas', 'Chana', 'Masoor'],
  },
  zaid: {
    name: 'Zaid',
    nameHindi: 'ज़ैद',
    months: [3, 4, 5, 6],
    months_names: ['Mar', 'Apr', 'May', 'Jun'],
    description: 'Short-duration summer crops',
    crops: ['Watermelon', 'Muskmelon', 'Cucumber', 'Moong', 'Maize'],
  },
};

export const SOIL_TYPES = [
  { id: 'alluvial', name: 'Alluvial Soil', nameHindi: 'जलोढ़ मिट्टी', description: 'Fertile, found in river plains', suitableCrops: ['Wheat', 'Rice', 'Sugarcane', 'Maize'] },
  { id: 'black', name: 'Black Soil', nameHindi: 'काली मिट्टी', description: 'Clay-rich, retains moisture, Deccan Plateau', suitableCrops: ['Cotton', 'Soybean', 'Jowar', 'Wheat'] },
  { id: 'red', name: 'Red Soil', nameHindi: 'लाल मिट्टी', description: 'Iron-rich, peninsular India', suitableCrops: ['Groundnut', 'Cotton', 'Tobacco', 'Millets'] },
  { id: 'laterite', name: 'Laterite Soil', nameHindi: 'लैटेराइट मिट्टी', description: 'Acidic, found in high rainfall areas', suitableCrops: ['Tea', 'Coffee', 'Rubber', 'Cashew'] },
  { id: 'arid', name: 'Arid/Desert Soil', nameHindi: 'मरुस्थलीय मिट्टी', description: 'Sandy, low organic matter, western India', suitableCrops: ['Bajra', 'Jowar', 'Groundnut'] },
  { id: 'saline', name: 'Saline Soil', nameHindi: 'लवणीय मिट्टी', description: 'High salt content, coastal areas', suitableCrops: ['Rice', 'Sugarbeet'] },
  { id: 'peaty', name: 'Peaty Soil', nameHindi: 'पीट मिट्टी', description: 'High organic content, Kerala/Bihar', suitableCrops: ['Rice', 'Jute'] },
  { id: 'forest', name: 'Forest/Mountain Soil', nameHindi: 'वन मिट्टी', description: 'Himalayan foothill regions', suitableCrops: ['Tea', 'Apple', 'Wheat'] },
];

export const WATER_SOURCES = ['Rain-fed', 'Canal', 'Borewell', 'Open Well', 'Drip Irrigation', 'Sprinkler', 'Pond/Tank', 'River'];

export const FARMING_TYPES = [
  { id: 'organic', name: 'Organic', nameHindi: 'जैविक', description: 'No synthetic inputs' },
  { id: 'conventional', name: 'Conventional', nameHindi: 'पारंपरिक', description: 'Chemical inputs allowed' },
  { id: 'mixed', name: 'Mixed', nameHindi: 'मिश्रित', description: 'Combination approach' },
  { id: 'natural', name: 'Natural Farming', nameHindi: 'प्राकृतिक', description: 'Zero-budget natural farming' },
];

export const SUBSCRIPTION_PLANS = {
  free: {
    name: 'Free',
    price: 0,
    features: ['Basic price data', 'AI chat (10/day)', 'Disease detection (5/month)', 'Community access'],
  },
  pro: {
    name: 'Pro',
    nameHindi: 'प्रो',
    price: 99,
    billingCycle: 'monthly',
    features: ['Real-time price data', 'Unlimited AI chat', 'Unlimited disease detection', 'Weather alerts', 'Yield prediction', 'Satellite view', 'Expert consultation', 'Market analytics', 'Priority support'],
  },
};

export const B2B_PLANS = {
  starter: {
    name: 'Starter',
    price: 25000,
    crops: 5,
    states: 3,
    apiCalls: 10000,
    features: ['Price trend data', 'Basic crop analytics', 'CSV export', 'Email support'],
  },
  growth: {
    name: 'Growth',
    price: 75000,
    crops: 20,
    states: 10,
    apiCalls: 50000,
    features: ['All Starter features', 'Disease insights', 'Farmer behavior data', 'API access', 'Custom reports', 'Dedicated support'],
  },
  enterprise: {
    name: 'Enterprise',
    price: 200000,
    crops: 'unlimited',
    states: 'all',
    apiCalls: 'unlimited',
    features: ['All Growth features', 'Real-time data streams', 'Custom data pipelines', 'White-label options', 'On-site training', '24/7 support', 'SLA guarantee'],
  },
};

export const CROP_EMOJIS = {
  Wheat: '🌾', Rice: '🍚', Maize: '🌽', Tomato: '🍅', Potato: '🥔', Onion: '🧅',
  Garlic: '🧄', Ginger: '🫚', Cotton: '☁️', Sugarcane: '🎋', Mango: '🥭',
  Banana: '🍌', Mustard: '🌼', Sunflower: '🌻', Chilli: '🌶️', Turmeric: '🟡',
  Groundnut: '🥜', Soybean: '🫘', Chana: '🫘', Arhar: '🫘', Moong: '🫘',
  Urad: '🫘', Masoor: '🫘', Barley: '🌾', Jowar: '🌾', Bajra: '🌾',
  Ragi: '🌾', Cauliflower: '🥦', Cabbage: '🥬', Brinjal: '🍆', Okra: '🌿',
  Peas: '🫛', Carrot: '🥕', Grapes: '🍇', Apple: '🍎', Orange: '🍊',
  Pomegranate: '❤️', Guava: '🍈', Papaya: '🍑', Watermelon: '🍉',
};

export const UNITS = ['Quintal', 'Kg', 'Ton', 'Bag', 'Piece', 'Dozen', 'Liter', 'Acre', 'Bigha', 'Hectare'];

export const DISEASE_CATEGORIES = [
  { id: 'fungal', name: 'Fungal Disease', nameHindi: 'फफूंद रोग', color: '#8B4513' },
  { id: 'bacterial', name: 'Bacterial Disease', nameHindi: 'जीवाणु रोग', color: '#DC143C' },
  { id: 'viral', name: 'Viral Disease', nameHindi: 'विषाणु रोग', color: '#9400D3' },
  { id: 'pest', name: 'Pest Attack', nameHindi: 'कीट आक्रमण', color: '#FF8C00' },
  { id: 'nutrient', name: 'Nutrient Deficiency', nameHindi: 'पोषक तत्व की कमी', color: '#DAA520' },
  { id: 'weather', name: 'Weather Damage', nameHindi: 'मौसम नुकसान', color: '#4682B4' },
];

export const EXPERT_SPECIALIZATIONS = [
  { id: 'crop_science', name: 'Crop Science', nameHindi: 'फसल विज्ञान' },
  { id: 'soil_health', name: 'Soil Health', nameHindi: 'मिट्टी स्वास्थ्य' },
  { id: 'pest_mgmt', name: 'Pest Management', nameHindi: 'कीट प्रबंधन' },
  { id: 'organic', name: 'Organic Farming', nameHindi: 'जैविक खेती' },
  { id: 'market', name: 'Market Strategy', nameHindi: 'बाजार रणनीति' },
  { id: 'water', name: 'Water Management', nameHindi: 'जल प्रबंधन' },
  { id: 'schemes', name: 'Govt Schemes', nameHindi: 'सरकारी योजनाएं' },
];

export const GOVT_SCHEME_CATEGORIES = [
  { id: 'subsidy', name: 'Subsidy', nameHindi: 'सब्सिडी' },
  { id: 'insurance', name: 'Insurance', nameHindi: 'बीमा' },
  { id: 'credit', name: 'Credit/Loan', nameHindi: 'ऋण' },
  { id: 'market', name: 'Market Support', nameHindi: 'बाजार सहायता' },
  { id: 'technology', name: 'Technology', nameHindi: 'प्रौद्योगिकी' },
  { id: 'water', name: 'Water Conservation', nameHindi: 'जल संरक्षण' },
  { id: 'organic', name: 'Organic Support', nameHindi: 'जैविक सहायता' },
];

// Flat major crops list (for dropdowns, filters, etc.)
export const MAJOR_CROPS = [
  'Wheat', 'Rice', 'Maize', 'Barley', 'Jowar', 'Bajra', 'Ragi',
  'Chana', 'Arhar/Tur', 'Moong', 'Urad', 'Masoor', 'Rajma', 'Soybean',
  'Tomato', 'Potato', 'Onion', 'Cabbage', 'Cauliflower', 'Brinjal',
  'Ladyfinger', 'Spinach', 'Carrot', 'Radish', 'Peas', 'Beans',
  'Mango', 'Banana', 'Apple', 'Grapes', 'Orange', 'Papaya', 'Guava',
  'Pomegranate', 'Watermelon', 'Sugarcane', 'Cotton', 'Jute',
  'Groundnut', 'Mustard', 'Sunflower', 'Sesame', 'Linseed',
  'Turmeric', 'Ginger', 'Garlic', 'Chili', 'Coriander', 'Cumin',
  'Green Fodder', 'Coconut', 'Arecanut', 'Pepper', 'Cardamom',
];

// Alias for full crops list
export const ALL_CROPS = MAJOR_CROPS;

// Price units
export const PRICE_UNITS = [
  { value: 'quintal', label: 'Per Quintal (क्विंटल)' },
  { value: 'kg', label: 'Per Kg (किलो)' },
  { value: 'ton', label: 'Per Ton (टन)' },
  { value: 'piece', label: 'Per Piece (नग)' },
  { value: 'dozen', label: 'Per Dozen (दर्जन)' },
];

// Crop advisory tips by crop (used in Dashboard)
export const CROP_ADVISORY_TIPS = {
  Wheat: ['Irrigate at crown root initiation stage', 'Apply NPK fertiliser 3 weeks after sowing', 'Watch for yellow rust after rains'],
  Rice: ['Transplant seedlings at 25-30 days age', 'Maintain 2-5 cm water level in paddy field', 'Apply urea in 3 splits'],
  Tomato: ['Stake plants when 30 cm tall', 'Spray calcium nitrate to prevent blossom end rot', 'Check for leaf curl virus weekly'],
  Potato: ['Hill up soil around plants after 3 weeks', 'Apply potash for better tuber development', 'Spray Mancozeb for early blight'],
  Onion: ['Avoid excess water at bulb formation stage', 'Stop irrigation 10 days before harvest', 'Cure bulbs in shade for 7-10 days'],
  default: ['Test your soil every 2 years', 'Use certified seeds for better yield', 'Practice crop rotation to maintain soil health'],
};

export const QUICK_CHAT_QUESTIONS = {
  hi: [
    'आज गेहूं का भाव क्या है?',
    'मेरी फसल में पीले पत्ते हैं, क्या करूं?',
    'इस मौसम में कौन सी फसल बोएं?',
    'इस हफ्ते का मौसम कैसा रहेगा?',
    'मिट्टी की जांच कैसे करें?',
    'पीएम किसान योजना की जानकारी दें',
  ],
  en: [
    'What is today\'s wheat price?',
    'My crop has yellow leaves, what should I do?',
    'Which crop to sow this season?',
    'How will the weather be this week?',
    'How to test soil health?',
    'Tell me about PM Kisan scheme',
  ],
  pa: [
    'ਅੱਜ ਕਣਕ ਦਾ ਭਾਅ ਕੀ ਹੈ?',
    'ਮੇਰੀ ਫ਼ਸਲ ਵਿੱਚ ਪੀਲੇ ਪੱਤੇ ਹਨ, ਕੀ ਕਰਾਂ?',
    'ਇਸ ਮੌਸਮ ਵਿੱਚ ਕਿਹੜੀ ਫ਼ਸਲ ਬੀਜਾਂ?',
    'ਇਸ ਹਫ਼ਤੇ ਦਾ ਮੌਸਮ ਕਿਹੋ ਜਿਹਾ ਰਹੇਗਾ?',
    'ਮਿੱਟੀ ਦੀ ਜਾਂਚ ਕਿਵੇਂ ਕਰੀਏ?',
    'PM ਕਿਸਾਨ ਯੋਜਨਾ ਬਾਰੇ ਦੱਸੋ',
  ],
};
